import omit from "lodash/omit";

/**
 * Flatten a tree DS by moving the children of each node
 * to the first level and setting the 'level' value on
 * those nodes.
 *
 * @param tree
 */
const flattenTree = (tree) => {
  const result = [];

  // Add all top-level nodes to stack with level=0.
  const stack = tree.map((topLevelNode) => ({ ...topLevelNode, level: 0 }));
  stack.reverse();

  while (stack.length) {
    const node = stack.pop();
    const isSubtree = node?.children != null && Array.isArray(node.children);

    if (!isSubtree) {
      result.push(node);
      continue;
    }

    // Push the exact same node without the children attribute
    // to be processed separately.
    result.push(omit(node, ["children"]));

    const reversedChildren = new Array(...node.children).reverse();
    for (const child of reversedChildren) {
      stack.push({
        ...child,
        level: node.level + 1,
        parentId: node.id,
      });
    }
  }

  return result;
};

export default flattenTree;
